import okaoAxios from '../helpers/axios'

export interface SendPayoutLinkSmsRequest {
  paymentLinkUrl: string
}

export interface SendPayoutLinkSmsResponse {
  status: string
}

/**
 * Sends payout claim link via SMS to the authenticated user's phone
 * 
 * @param paymentLinkUrl - The Tremendous claim link URL to send
 * @returns Response with status
 */
export async function sendPayoutLinkSms(
  paymentLinkUrl: string,
): Promise<SendPayoutLinkSmsResponse> {
  const body: SendPayoutLinkSmsRequest = { paymentLinkUrl }
  const response = await okaoAxios.post<SendPayoutLinkSmsResponse>(
    '/wallet/payouts/send-sms',
    body,
  )
  return response.data
}

// A reward in the eater's inbox: a redeemed gift card / payout with its claim link.
export interface RewardCard {
  id: string
  amountCents: number
  currency?: string
  status: string
  claimUrl?: string | null
  rewardCode?: string
  created?: string
}

/**
 * Fetches the eater's reward inbox — every redeemed gift card / payout with its claim link, so a
 * reward can be (re)claimed in-app even when the account email is fake/undeliverable. Newest first.
 */
export async function getRewardsInbox(): Promise<RewardCard[]> {
  const response = await okaoAxios.get<RewardCard[]>('/wallet/rewards')
  return response.data ?? []
}

/**
 * Regenerates a fresh claim link for a wallet entry (Tremendous links expire in ~1 day). Use when a
 * stored claim link is missing or has expired.
 *
 * @param walletEntryId - the reward's wallet entry id
 * @returns the new claim URL
 */
export async function regenerateClaimLink(
  walletEntryId: string,
): Promise<string> {
  const response = await okaoAxios.post<{ claimUrl: string }>(
    `/wallet/payouts/${walletEntryId}/regenerate-link`,
  )
  return response.data.claimUrl
}
